import React from 'react';
import { Modules, P100CheckoutPage as checkoutType } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';

import { Checkout } from '../../CheckOutLayout/components/Checkout';

type P100CheckoutProps = checkoutType;

export const P100CheckoutPage = (props: P100CheckoutProps) => (
    <>
        <DynamicBlockList elements={props.pageElements as Modules[]} />
        <Checkout />
        <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
    </>
);
